<template>
  <div>
    <search-form
      :fetchData="fetch"
      ref="searchFormRef"
      :handelSearch="handelSearch"
      :collection="formCollection"
      :addBtn="false"
    ></search-form>
    <a-modal
      v-model:open="open"
      :title="pageName"
      :footer="null"
      :destroyOnClose="true"
      :keyboard="false"
      class="action-form-model-small"
    >
      <action
        :v-if="open"
        @submit="clickOk"
        :isEdit="isEdit"
        :editData="editData"
        :data="tableData"
        :idField="idField"
        :disabled="true"
      ></action>
    </a-modal>
    <a-table
      :columns="columns"
      :row-key="(record) => record.uuid"
      :data-source="tableData"
      :pagination="pagination"
      :loading="loading"
      @change="handleTableChange"
      :scroll="{x: 'max-content'}"
      :customRow="handleRow"
      size="small"
    >
      <template #bodyCell="{ column, record }">
        <template v-if="column.key === 'status'">
          {{
            codeToText(record.personBlackWhiteList.status, Enum.status.value)
          }}
        </template>
        <template v-if="column.key === 'idcard_type'">
          {{ codeToText(record.personBlackWhiteList.idcard_type, Enum.documentType.value) }}
        </template>
        <template v-if="column.key === 'type'">
          {{ codeToText(record.type, Enum.blackWhiteListType.value) }}
        </template>
        <template v-if="column.key === 'gender'">
          {{ codeToText(record.personBlackWhiteList?.gender, gender) }}
        </template>
        <template v-if="column.key === 'create_user_id'">
          {{
            codeToText(
              record.personBlackWhiteList.create_user_id,
              Enum.user.value
            )
          }}
        </template>
        <template v-if="column.key === 'update_user_id'">
          {{ codeToText(record.personBlackWhiteList.update_user_id, Enum.user.value) }}
        </template>
        <template v-if="column.key === 'time_range'">
          {{ record.personBlackWhiteList.start_time }} 至
          {{ record.personBlackWhiteList.end_time }}
        </template>
        <template v-if="column.dataInObject">
          {{
            record[column.dataInObject] &&
            record[column.dataInObject][column.dataIndex]
          }}
        </template>
        <template v-if="column.key === 'action'">
          <span>
            <a-button
              @click="showEditModal(record)"
              :loading="loadingRecord === record"
              v-if="record.personBlackWhiteList?.status === 1"
            >
              审核
            </a-button>
          </span>
        </template>
      </template>
    </a-table>
  </div>
</template>
<script setup>
  import { ref, onMounted, toRefs, computed } from 'vue'
  import { useStore } from 'vuex'
  import { getData, revoke } from '@/api/black_white_list/person_list_approval'
  import action from './action'
  import { message } from 'ant-design-vue'
  import searchForm from '@/components/search_form'
  import { codeToText, constantToOptions } from '@/utils/format'
  import { approvalOperation, gender } from '@/utils/common'
  //初始化
  const pageName = '人员黑白名单审核'
  const idField = 'process_task_id' //响应数据的id的字段名
  const store = useStore()
  const Enum = toRefs(store.state.common)

  //1、搜索框
  const formCollection = [
    {
      type: 'select',
      field: 'gender',
      label: '性别',
      options: constantToOptions(gender),
      width: '130px',
    },
    {
      type: 'select',
      field: 'type',
      storeOptions: 'blackWhiteListType',
      filterNegative: true,
      // defaultValue: 1,
      label: '名单类型',
      width: '130px',
      'allow-clear': true,
    },
    // {
    //   type: 'select',
    //   field: 'operation',
    //   options: constantToOptions(approvalOperation),
    //   label: '审核类型',
    //   // defaultValue: 1,
    //   width: '130px',
    //   'allow-clear': true,
    // },
  ]
  const searchFormRef = ref()
  function handelSearch() {
    pagination.value.current = 1
    fetch()
    const params = {
      ...searchFormRef.value.formState
    }
    store.commit('search/setBlackPersonApproval', params)
  }

  //2、表格
  const columns = [
    {
      title: '姓名',
      dataIndex: 'name',
      key: 'name',
      align: 'left',
      dataInObject: 'personBlackWhiteList',
    },
    // {
    //   title: '性别',
    //   dataIndex: 'gender',
    //   key: 'gender',
    //   align: 'left',
    //   // dataInObject: 'personBlackWhiteList',
    // },
    {
      title: '证件类型',
      key: 'idcard_type',
      align: 'left',
      dataInObject: 'personBlackWhiteList',
    },
    {
      title: '证件号',
      dataIndex: 'idcard',
      key: 'idcard',
      align: 'left',
      dataInObject: 'personBlackWhiteList',
    },
    {
      title: '名单类型',
      dataIndex: 'type',
      key: 'type',
      align: 'left',
    },
    {
      title: '时间范围',
      key: 'time_range',
      align: 'left',
    },
    {
      title: '审核状态',
      dataIndex: 'status',
      key: 'status',
      align: 'left',
    },
    {
      title: '原因备注',
      dataIndex: 'in_reason',
      key: 'in_reason',
      align: 'left',
      dataInObject: 'personBlackWhiteList',
    },
    {
      title: '提交人',
      dataIndex: 'create_user_id',
      key: 'create_user_id',
      align: 'left',
    },
    {
      title: '修改人',
      dataIndex: 'update_user_id',
      key: 'update_user_id',
      align: 'left',
    },
    {
      title: '操作',
      dataIndex: 'action',
      key: 'action',
      align: 'left',
      fixed: 'right',
      width: '120px',
    },
  ]

  const tableData = ref([])
  const loading = ref(false)
  const loadingRecord = ref()
  const pagination = ref({
    current: 1,
    pageSize: 10,
    showLessItems: true,
    showQuickJumper: true,
    showSizeChanger: true,
  })

  function handleTableChange(page) {
    pagination.value = { ...pagination.value, ...page }
    fetch()
  }

  function fetch() {
    //获取表单值
    const formState = searchFormRef.value?.formState

    loading.value = true
    getData({
      size: pagination.value.pageSize,
      pn: pagination.value.current,
      ...formState,
    }).then(({ data }) => {
      loading.value = false
      tableData.value = data.list
      pagination.value.total = data.total
    })
  }

  const handleRow = (record) => {
    return {
      ondblclick: (event) => {
        event.stopPropagation();
        showEditModal(record);
      }
    }
  }
  
  const cachedSearchParams = computed(() => store.state.search.searchBlackPersonApproval)
  onMounted(() => {
    for (const key in cachedSearchParams.value) {
      searchFormRef.value.formState[key] = cachedSearchParams.value[key]
    }
    fetch()
  })

  //3、审核
  const open = ref(false)
  const isEdit = ref(true)
  const editData = ref(null)
  const showEditModal = async (data) => {
    editData.value = data
    open.value = true
  }

  function clickOk() {
    fetch()
    handleOk()
    clearEditData()
  }

  const handleOk = () => {
    open.value = false
  }
  const clearEditData = () => {
    editData.value = null
  }

  //4、撤销审核
  async function delRow(data) {
    const res = await revoke({ id: data[idField] })
    if (res.success) {
      message.success('撤销审核成功！')
      fetch()
    } else {
      message.warn('撤销审核失败' + res.message)
    }
  }
</script>
